import { NgModule } from '@angular/core';
import {
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbTreeGridModule,
  NbDialogModule,
  NbButtonModule,
  NbSelectModule,
  NbCheckboxModule,
  NbWindowModule,
  NbRadioModule,
  NbTabsetModule,
  NbTooltipModule,
  NbAccordionModule,
  NbListModule,
  NbProgressBarModule,
  NbToggleModule,
  NbPopoverModule,
  NbUserModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { InternalAdminRoutingModule, routedComponents } from './internal-admin-routing.module';
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmOperationComponent } from '../../@theme/components/confirm-operation/confirm-operation.component';
import { PickListModule } from 'primeng/picklist';
import { ResultDTOService } from '../../@core/utils/result-dto.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
defineLocale('pt-br', ptBrLocale);

import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxEchartsModule } from 'ngx-echarts';
import { TabsModule } from "ngx-tabs";

import { ChartsModule } from 'ng2-charts';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgbDropdownModule, NgbProgressbarModule, NgbRatingModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ShowCompanyComponent } from './company/show/show-company.component';
import { CompanyComponent } from './company/company.component';


const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'codeIndex',
  optionTextField: 'description',
  keepSelectedItems: false,
};

@NgModule({
  imports: [
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbTooltipModule,
    NbInputModule,
    NbSelectModule,
    ReactiveFormsModule,
    ThemeModule,
    NbButtonModule,
    InternalAdminRoutingModule,
    Ng2SmartTableModule,
    NbAccordionModule,
    NbCheckboxModule,
    NbDialogModule.forChild(),
    NbWindowModule.forChild(),
    NgxSelectModule.forRoot(CustomSelectOptions),
    FormsModule,
    PickListModule,
    NbRadioModule,
    NbTabsetModule,
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    NbListModule,
    NbProgressBarModule,
    ChartsModule,
    NbRadioModule,
    NbPopoverModule,
    NbUserModule,
    QuillModule.forRoot(),
    NgxEchartsModule,
    TabsModule,
    NbToggleModule,
    TableModule,
    InfiniteScrollModule,
    NgbProgressbarModule,
    NgbRatingModule,
    TagCloudModule,
    NbSpinnerModule,
    DropdownModule,
    InputNumberModule,
    InputTextModule,
    NbTabsetModule,
    NgbTooltipModule,
    NgbTabsetModule,
    NgbDropdownModule,
    PickListModule,
  ],

  declarations: [
    ...routedComponents,
  ],
  providers: [
    ResultDTOService,
  ],
  entryComponents: [CompanyComponent, ShowCompanyComponent, ConfirmOperationComponent],
})
export class InternalAdminModule {
}
